import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEntitlements } from "../entitlements/EntitlementContext";
import "./Billing.css";

const POLL_INTERVAL_MS = 1500;
const POLL_MAX_ATTEMPTS = 20;

export default function BillingSuccess() {
  const navigate = useNavigate();
  const entitlement = useEntitlements();
  const [phase, setPhase] = useState("waiting");
  const [message, setMessage] = useState("");

  useEffect(() => {
    let cancelled = false;
    let timer;

    (async () => {
      for (
        let attempt = 0;
        attempt < POLL_MAX_ATTEMPTS && !cancelled;
        attempt += 1
      ) {
        try {
          const status = await entitlement.refresh();
          if (status?.entitled) {
            setPhase("active");
            return;
          }
        } catch (err) {
          setMessage(err?.message || "Unable to check subscription status");
        }

        await new Promise((resolve) => {
          timer = window.setTimeout(resolve, POLL_INTERVAL_MS);
        });
      }

      if (!cancelled) setPhase("pending");
    })();

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [entitlement.refresh]);

  const active = phase === "active";

  return (
    <main className="billing-shell billing-state-page">
      <div className="billing-state-card">
        <div
          className={`billing-state-icon ${
            active ? "billing-state-icon--active" : ""
          }`}
        >
          {active ? (
            "✓"
          ) : (
            <span className="billing-spinner" aria-hidden="true" />
          )}
        </div>

        <div className="billing-brand-kicker">PLAYSWITHGURU</div>

        {active ? (
          <>
            <h1>You’re in.</h1>
            <p className="billing-state-lead">
              Your subscription is active and your PWG intelligence access has
              been confirmed.
            </p>

            <div className="billing-confirmation-note">
              Stripe’s signed webhook confirmed your subscription.
            </div>
          </>
        ) : (
          <>
            <h1>Activating your subscription</h1>
            <p className="billing-state-lead">
              {phase === "pending"
                ? "Confirmation is taking longer than expected. Your payment redirect is not being used as proof of access."
                : "Waiting for Stripe’s signed webhook confirmation…"}
            </p>

            {message && (
              <div className="billing-inline-error">{message}</div>
            )}
          </>
        )}

        <div className="billing-state-actions">
          {!active && (
            <button
              className="billing-cta billing-cta--secondary"
              onClick={() => entitlement.refresh()}
            >
              Refresh Status
            </button>
          )}

          <button
            className="billing-cta billing-cta--gold"
            onClick={() => navigate("/", { replace: true })}
          >
            {active ? "Enter PlaysWithGuru" : "Back to App"}
          </button>
        </div>
      </div>
    </main>
  );
}
